export default "__VITE_ASSET__CG8LnxKv__"